/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateActivityDto } from '../model';
// @ts-ignore
import type { CreateActivityResponseDto } from '../model';
// @ts-ignore
import type { GarminWebhookDto } from '../model';
// @ts-ignore
import type { GarminWebhookResponseDto } from '../model';
// @ts-ignore
import type { GetActivityResponseDto } from '../model';
// @ts-ignore
import type { GetAllActivitiesResponseDto } from '../model';
// @ts-ignore
import type { PaginatedActivitiesResponseDto } from '../model';
// @ts-ignore
import type { UpdateActivityDto } from '../model';
// @ts-ignore
import type { UpdateActivityResponseDto } from '../model';
/**
 * ActivitiesApi - axios parameter creator
 * @export
 */
export const ActivitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new activity
         * @param {CreateActivityDto} createActivityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesControllerCreateActivity: async (createActivityDto: CreateActivityDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createActivityDto' is not null or undefined
            assertParamExists('activitiesControllerCreateActivity', 'createActivityDto', createActivityDto)
            const localVarPath = `/api/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createActivityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single activity by ID
         * @param {string} id Activity ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesControllerFindActivity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('activitiesControllerFindActivity', 'id', id)
            const localVarPath = `/api/activities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all activities for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesControllerFindAllActivities: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all activities with pagination
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search query to filter challenges by title or description
         * @param {boolean} [isActive] Filter by active status (true &#x3D; active, false &#x3D; inactive/cancelled)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesControllerFindAllActivitiesPaginated: async (page?: number, limit?: number, search?: string, isActive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/activities/paginated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Process Garmin webhook activities
         * @param {GarminWebhookDto} garminWebhookDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesControllerProcessGarminWebhook: async (garminWebhookDto: GarminWebhookDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'garminWebhookDto' is not null or undefined
            assertParamExists('activitiesControllerProcessGarminWebhook', 'garminWebhookDto', garminWebhookDto)
            const localVarPath = `/api/activities/garmin/push`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(garminWebhookDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing activity by ID
         * @param {string} id Activity ID
         * @param {UpdateActivityDto} updateActivityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesControllerUpdateActivity: async (id: string, updateActivityDto: UpdateActivityDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('activitiesControllerUpdateActivity', 'id', id)
            // verify required parameter 'updateActivityDto' is not null or undefined
            assertParamExists('activitiesControllerUpdateActivity', 'updateActivityDto', updateActivityDto)
            const localVarPath = `/api/activities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateActivityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivitiesApi - functional programming interface
 * @export
 */
export const ActivitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new activity
         * @param {CreateActivityDto} createActivityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activitiesControllerCreateActivity(createActivityDto: CreateActivityDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateActivityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activitiesControllerCreateActivity(createActivityDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.activitiesControllerCreateActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a single activity by ID
         * @param {string} id Activity ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activitiesControllerFindActivity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActivityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activitiesControllerFindActivity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.activitiesControllerFindActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all activities for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activitiesControllerFindAllActivities(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAllActivitiesResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activitiesControllerFindAllActivities(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.activitiesControllerFindAllActivities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all activities with pagination
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search query to filter challenges by title or description
         * @param {boolean} [isActive] Filter by active status (true &#x3D; active, false &#x3D; inactive/cancelled)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activitiesControllerFindAllActivitiesPaginated(page?: number, limit?: number, search?: string, isActive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedActivitiesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activitiesControllerFindAllActivitiesPaginated(page, limit, search, isActive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.activitiesControllerFindAllActivitiesPaginated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Process Garmin webhook activities
         * @param {GarminWebhookDto} garminWebhookDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activitiesControllerProcessGarminWebhook(garminWebhookDto: GarminWebhookDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GarminWebhookResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activitiesControllerProcessGarminWebhook(garminWebhookDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.activitiesControllerProcessGarminWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing activity by ID
         * @param {string} id Activity ID
         * @param {UpdateActivityDto} updateActivityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activitiesControllerUpdateActivity(id: string, updateActivityDto: UpdateActivityDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateActivityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activitiesControllerUpdateActivity(id, updateActivityDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.activitiesControllerUpdateActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActivitiesApi - factory interface
 * @export
 */
export const ActivitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivitiesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new activity
         * @param {CreateActivityDto} createActivityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesControllerCreateActivity(createActivityDto: CreateActivityDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateActivityResponseDto> {
            return localVarFp.activitiesControllerCreateActivity(createActivityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single activity by ID
         * @param {string} id Activity ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesControllerFindActivity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetActivityResponseDto> {
            return localVarFp.activitiesControllerFindActivity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all activities for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesControllerFindAllActivities(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetAllActivitiesResponseDto>> {
            return localVarFp.activitiesControllerFindAllActivities(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all activities with pagination
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search query to filter challenges by title or description
         * @param {boolean} [isActive] Filter by active status (true &#x3D; active, false &#x3D; inactive/cancelled)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesControllerFindAllActivitiesPaginated(page?: number, limit?: number, search?: string, isActive?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedActivitiesResponseDto> {
            return localVarFp.activitiesControllerFindAllActivitiesPaginated(page, limit, search, isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Process Garmin webhook activities
         * @param {GarminWebhookDto} garminWebhookDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesControllerProcessGarminWebhook(garminWebhookDto: GarminWebhookDto, options?: RawAxiosRequestConfig): AxiosPromise<GarminWebhookResponseDto> {
            return localVarFp.activitiesControllerProcessGarminWebhook(garminWebhookDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing activity by ID
         * @param {string} id Activity ID
         * @param {UpdateActivityDto} updateActivityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesControllerUpdateActivity(id: string, updateActivityDto: UpdateActivityDto, options?: RawAxiosRequestConfig): AxiosPromise<UpdateActivityResponseDto> {
            return localVarFp.activitiesControllerUpdateActivity(id, updateActivityDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActivitiesApi - object-oriented interface
 * @export
 * @class ActivitiesApi
 * @extends {BaseAPI}
 */
export class ActivitiesApi extends BaseAPI {
    /**
     * 
     * @summary Create a new activity
     * @param {CreateActivityDto} createActivityDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public activitiesControllerCreateActivity(createActivityDto: CreateActivityDto, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).activitiesControllerCreateActivity(createActivityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single activity by ID
     * @param {string} id Activity ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public activitiesControllerFindActivity(id: string, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).activitiesControllerFindActivity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all activities for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public activitiesControllerFindAllActivities(options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).activitiesControllerFindAllActivities(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all activities with pagination
     * @param {number} [page] Page number (default: 1)
     * @param {number} [limit] Number of items per page (default: 10, max: 100)
     * @param {string} [search] Search query to filter challenges by title or description
     * @param {boolean} [isActive] Filter by active status (true &#x3D; active, false &#x3D; inactive/cancelled)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public activitiesControllerFindAllActivitiesPaginated(page?: number, limit?: number, search?: string, isActive?: boolean, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).activitiesControllerFindAllActivitiesPaginated(page, limit, search, isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Process Garmin webhook activities
     * @param {GarminWebhookDto} garminWebhookDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public activitiesControllerProcessGarminWebhook(garminWebhookDto: GarminWebhookDto, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).activitiesControllerProcessGarminWebhook(garminWebhookDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing activity by ID
     * @param {string} id Activity ID
     * @param {UpdateActivityDto} updateActivityDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public activitiesControllerUpdateActivity(id: string, updateActivityDto: UpdateActivityDto, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).activitiesControllerUpdateActivity(id, updateActivityDto, options).then((request) => request(this.axios, this.basePath));
    }
}

